import type { i18n } from 'i18next'
import { uiResources } from './resources'

/**
 * Registers UI translation bundles with the given i18n instance.
 * This should be called by the app before rendering any UI components.
 */
export function registerUITranslations(i18nInstance: i18n) {
  for (const [lng, namespaces] of Object.entries(uiResources)) {
    for (const [ns, translations] of Object.entries(namespaces)) {
      const uiNamespace = `ui-${ns}`
      i18nInstance.addResourceBundle(lng, uiNamespace, translations, true, true)
    }
  }
}
